// src/components/eventos/EventosMain.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Importar os componentes de eventos
import EventosHome from './EventosHome';
import EventosCadastro from './views/EventosCadastro';
import EventosDiretor from './views/EventosDiretor';
import EventosOperacional from './views/EventosOperacional';
import EventosPalestrante from './views/EventosPalestrante';
import EventoRevisaoPage from './views/EventoRevisaoPage';
import EventosRelatorios from './views/EventosRelatorios';

const EventosMain = ({ supabase, session, clienteData, onLogout }) => {
    return (
        <Routes>
            {/* Rota principal - seleção de módulos */}
            <Route
                index
                element={
                    <EventosHome
                        supabase={supabase}
                        session={session}
                        clienteData={clienteData}
                        onLogout={onLogout}
                    />
                }
            />

            {/* Rota de cadastro de eventos */}
            <Route
                path="cadastro"
                element={
                    <EventosCadastro
                        supabase={supabase}
                        session={session}
                        clienteData={clienteData}
                        onLogout={onLogout}
                    />
                }
            />

            {/* Rota da visão do diretor */}
            <Route
                path="diretor"
                element={
                    <EventosDiretor
                        supabase={supabase}
                        session={session}
                        clienteData={clienteData}
                        onLogout={onLogout}
                    />
                }
            />

            {/* Rota da página de revisão do evento */}
            <Route
                path="revisao/:eventoId"
                element={
                    <EventoRevisaoPage
                        supabase={supabase}
                        session={session}
                        clienteData={clienteData}
                        onLogout={onLogout}
                    />
                }
            />

            {/* Rota de relatórios */}
            <Route
                path="relatorios"
                element={
                    <EventosRelatorios
                        supabase={supabase}
                        session={session}
                        clienteData={clienteData}
                        onLogout={onLogout}
                    />
                }
            />

            {/* Rota da visão operacional */}
            <Route
                path="operacional"
                element={
                    <EventosOperacional
                        supabase={supabase}
                        session={session}
                        clienteData={clienteData}
                        onLogout={onLogout}
                    />
                }
            />

            {/* Rota da visão do palestrante */}
            <Route
                path="palestrante"
                element={
                    <EventosPalestrante
                        supabase={supabase}
                        session={session}
                        clienteData={clienteData}
                        onLogout={onLogout}
                    />
                }
            />

            {/* Redirecionar rotas antigas para a nova estrutura */}
            <Route path="coordenador" element={<Navigate to="/eventos/operacional" replace />} />
            <Route path="admin" element={<Navigate to="/eventos/diretor" replace />} />

            {/* Rota catch-all - redirecionar para a home de eventos */}
            <Route path="*" element={<Navigate to="/eventos" replace />} />
        </Routes>
    );
};

export default EventosMain;
